import { render, staticRenderFns } from "./OrderInformationCard.vue?vue&type=template&id=b5af2a30&scoped=true&"
import script from "./OrderInformationCard.vue?vue&type=script&lang=ts&"
export * from "./OrderInformationCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInformationCard.vue?vue&type=style&index=0&id=b5af2a30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5af2a30",
  null
  
)

export default component.exports